export const ROLLOUT_FEATURES = Object.freeze({
  AI: "ai",
  NO_REPLY: "no_reply",
  OFFICIAL_NUMBER: "official_number",
  BROADCAST_METRICS: "broadcast_metrics",
  ALL_CONTACTS: "all_contacts",
  TICKET_FILTERS: "ticket_filters",
  TICKETS_UI: "tickets_ui",
  DASHBOARD_V2: "dashboard_v2",
  METRICS_V2: "metrics_v2",
  AI_REACTIVATION_V2: "ai_reactivation_v2",
  REMINDERS_V2: "reminders_v2",
  QUICK_MESSAGES_SEQUENCE: "quick_messages_sequence",
  META_ERROR: "meta_error",
  TEMPLATE_ERROR_V2: "template_error_v2",
  WEBHOOK_TOKEN: "webhook_token"
});

/**
 * The flags come from the authenticated session response. Unknown, absent or
 * malformed data is always disabled so a frontend build can be deployed dark
 * without exposing any pilot UI to another company.
 */
export const hasRolloutFeature = (user, feature) =>
  Boolean(
    feature &&
    user &&
    user.rolloutFeatures &&
    user.rolloutFeatures[feature] === true
  );

export const hasAnyRolloutFeature = user =>
  Boolean(
    user &&
    user.rolloutFeatures &&
    Object.values(ROLLOUT_FEATURES).some(feature =>
      hasRolloutFeature(user, feature)
    )
  );

/**
 * Socket events can contain only the database-backed portion of a user. Keep
 * authenticated-session fields when they are absent from that partial payload.
 */
export const mergeAuthenticatedUserUpdate = (currentUser, incomingUser) => {
  if (!incomingUser || typeof incomingUser !== "object") return currentUser;
  if (!currentUser || typeof currentUser !== "object") return incomingUser;

  return {
    ...currentUser,
    ...incomingUser,
    rolloutFeatures: Object.prototype.hasOwnProperty.call(incomingUser, "rolloutFeatures")
      ? incomingUser.rolloutFeatures
      : currentUser.rolloutFeatures,
    companyAccess: Object.prototype.hasOwnProperty.call(incomingUser, "companyAccess")
      ? incomingUser.companyAccess
      : currentUser.companyAccess
  };
};
